import { LogManager } from '../../../common/port/log/log.manager.port';
import { AccountMetricsInsightsSentimentSummaryEntityMapper } from '../../../infrastructure/mappers/challenge-insights/account-metrics-insights-sentiment-summary.entity.mapper';
import { GetAccountMetricsInsightsSentimentSummaryRequestDto } from '../../dtos/challenge-insights/get-account-metrics-insights-sentiment-summary.request.dto';
import { GetAccountMetricsInsightsSentimentSummaryResponseDto } from '../../dtos/challenge-insights/get-account-metrics-insights-sentiment-summary.response.dto';
import { GetAccountMetricsInsightsSentimentSummaryQuery } from '../../queries/challenge-insights/get-account-metrics-insights-sentiment-summary.query';

export class GetAccountMetricsInsightsSentimentSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountMetricsInsightsSentimentSummaryQuery,
    protected readonly mapper: AccountMetricsInsightsSentimentSummaryEntityMapper
  ) {}

  async get(
    props: GetAccountMetricsInsightsSentimentSummaryRequestDto
  ): Promise<GetAccountMetricsInsightsSentimentSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetAccountMetricsInsightsSentimentSummaryController.get encountered an error ${error}`
      );
    }
  }
}
